import { execute } from '../../helpers/apiInstance';

export const createProject = (dataObj) => {
  return execute('POST', `/ui/apis/app-enroll`, dataObj, 'json');
};

export const projectDetailsInfo = (dataObj) => {
  return execute('POST', `/ui/apis/get-project-dtls?${new URLSearchParams({
    AppNb: dataObj.AppNb,
  }).toString()}`, {}, 'json');
};

export const searchProjects = (dataObj, pageParams) => {
  const requestObj = {
    ...dataObj,
    pagE_NUMBER: pageParams.page,
    pagE_SIZE: pageParams.pageSize,
  };
  return execute('POST', `/ui/apis/search-projects`, requestObj, 'json');
};

export const getStatusList = (dataObj) => {
  if (dataObj.opco === '') {
    return execute('GET', `/ui/apis/get-status-list`);
  } else {
    return execute('POST', `/ui/apis/get-opco-status`, dataObj, 'json');
  }
};

export const getDeleteProject = (data) => {
  return execute(
    'POST',
    `/ui/apis/get-delete-status?${new URLSearchParams({
      AppNb: data?.AppNb,
      ActionType: data?.ActionType
    }).toString()}`,
    {},
    'json'
  );
};

//DOCUMENT API
export const getProjectDocs = (objectKey) => {
  return execute(
    'GET',
    `/ui/apis/get-project-document?${new URLSearchParams({
      ObjectKey: objectKey,
    }).toString()}`,
    {},
    'json'
  );
};

export const getDocumentbyId = (docDetails) => {
  return execute(
    'POST',
    `/ui/apis/get-document`,
    docDetails,
    'json'
  );
};
